<!--SÉLECTION DE COULEUR - POUR BOUTON DE CAISSE-->
<template>
    <div id="s-colorSelector">

        <b-row class="justify-content-center">
            <b-button @click="$bvModal.show('modal-1')" :class="'btnShowColor' + ' ' + btnColor" >{{selectColorTxt}}</b-button>
        <div>
            <b-modal :body-bg-variant="getTheme.light" :header-bg-variant="getTheme.dark" :header-text-variant="getTheme.light" id="modal-1" :title="$t('cmp_ChoisirCouleur')" hide-footer>
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-list-group-item class="color0"  @click="selectColor('0')">{{$t('cmp_PasAfficher')}}</b-list-group-item>
                    </b-col>
                    <b-col xs="6" sm="6" md="6" lg="6" xl="6">
                        <b-list-group>
                          <b-list-group-item :class="sColor == '1' ? 'select color1 colorSize' : 'color1 colorSize'" @click="selectColor('1')"></b-list-group-item>
                          <b-list-group-item :class="sColor == '11' ? 'select color11 colorSize' : 'color11 colorSize'" @click="selectColor('11')"></b-list-group-item>
                          <b-list-group-item :class="sColor == '14' ? 'select color14 colorSize' : 'color14 colorSize'" @click="selectColor('14')"></b-list-group-item>
                          <b-list-group-item :class="sColor == '5' ? 'select color5 colorSize' : 'color5 colorSize'" @click="selectColor('5')"></b-list-group-item>
                          <b-list-group-item :class="sColor == '13' ? 'select color13 colorSize' : 'color13 colorSize'" @click="selectColor('13')"></b-list-group-item>
                          <b-list-group-item :class="sColor == '9' ? 'select color9 colorSize' : 'color9 colorSize'" @click="selectColor('9')"></b-list-group-item>
                          <b-list-group-item :class="sColor == '2' ? 'select color2 colorSize' : 'color2 colorSize'" @click="selectColor('2')"></b-list-group-item>
                        </b-list-group>
                    </b-col>
                    <b-col xs="6" sm="6" md="6" lg="6" xl="6">
                        <b-list-group>
                          <b-list-group-item :class="sColor == '8' ? 'select color8 colorSize' : 'color8 colorSize'" @click="selectColor('8')"></b-list-group-item>
                          <b-list-group-item :class="sColor == '12' ? 'select color12 colorSize' : 'color12 colorSize'" @click="selectColor('12')"></b-list-group-item>
                          <b-list-group-item :class="sColor == '6' ? 'select color6 colorSize' : 'color6 colorSize'" @click="selectColor('6')"></b-list-group-item>
                          <b-list-group-item :class="sColor == '10' ? 'select color10 colorSize' : 'color10 colorSize'" @click="selectColor('10')"></b-list-group-item>
                          <b-list-group-item :class="sColor == '3' ? 'select color3 colorSize' : 'color3 colorSize'" @click="selectColor('3')"></b-list-group-item>
                          <b-list-group-item :class="sColor == '4' ? 'select color4 colorSize' : 'color4 colorSize'" @click="selectColor('4')"></b-list-group-item>
                          <b-list-group-item :class="sColor == '7' ? 'select color7 colorSize' : 'color7 colorSize'" @click="selectColor('7')"></b-list-group-item>
                        </b-list-group>
                    </b-col>
                    
                </b-row>

            </b-modal>
        </div>

            <!--<div class="showColorForm"></div>-->

        </b-row>

    </div>
</template>


<script>
import {mapGetters} from 'vuex'

export default{
    name: 's-colorSelector',
    props: {
        value: Number,
    },
    data() {
        return {
            btnColor: 'colorOff',
            selectColorTxt: this.$t('cmp_PasAfficher'),
            sColor: '0'
        }
    },
    methods: {
        setColor(color){
            if (color == '0')
            {
                this.btnColor = 'colorOff'
                this.selectColorTxt = this.$t('cmp_PasAfficher')
            }
            
            else
            {
                this.btnColor = 'color' + color
                this.selectColorTxt = this.$t('cmp_Afficher')
            }
            this.sColor = color;
        },
        selectColor(color){
            if (color == '0')
            {
                this.btnColor = 'colorOff'
                this.selectColorTxt = this.$t('cmp_PasAfficher')
            }
            
            else
            {
                this.btnColor = 'color' + color
                this.selectColorTxt = this.$t('cmp_Afficher')
            }
            
            this.sColor = color;
            this.$emit('update:returnValue', color)
            this.$bvModal.hide('modal-1')
        }
    },
    computed: {
        ...mapGetters(['getTheme', 'getLanguage']),
        status() {
            return this.value
        }
    },
    watch: {
        getLanguage: function() {
                if (this.sColor == '0')
                {
                    this.selectColorTxt = this.$t('cmp_PasAfficher')
                }
                
                else
                {
                    this.selectColorTxt = this.$t('cmp_Afficher')
                }
        },
        value: function() {
            this.setColor(this.value)
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/components/colorSelector.scss'
</style>